export default __webpack_public_path__ + "img/deedbc38d80d947d9cea0dda35cadc34.png";